var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"voltar-login"},[_c('router-link',{attrs:{"to":_vm.to}},[_c('img',{attrs:{"src":require("@/assets/img/icons/long-arrow.svg")}}),_vm._v(" "+_vm._s(_vm.text)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }